module.exports = __webpack_public_path__ + "img/symbol_12.177c347a.png";